// shell/components/entity-fields/view-renderers/number-renderer.ts

import { createElement } from '../../../utils/dom';
import type { NumberViewField } from '../../entity-view/types';

/**
 * Renders a number field value with optional formatting.
 */
export function renderNumberView<T>(
    field: NumberViewField<T>,
    value: unknown,
    model: T
): HTMLElement {
    const container = createElement('div', {
        className: 'ev-field-view ev-field-view--number',
    });

    if (value === null || value === undefined) {
        container.classList.add('ev-field-view--empty');
        container.textContent = '—';
        return container;
    }

    const numValue = typeof value === 'number' ? value : parseFloat(String(value));

    if (isNaN(numValue)) {
        container.classList.add('ev-field-view--empty');
        container.textContent = '—';
        return container;
    }

    let displayValue: string;
    if (field.format) {
        displayValue = field.format(numValue, model);
    } else {
        // Default number formatting with locale
        displayValue = numValue.toLocaleString();
    }

    container.textContent = displayValue;
    return container;
}
